import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const changePIN = createAsyncThunk(
  "changePIN/changePIN",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post('update-pin', payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

const changePINSlice = createSlice({
  name: "changePIN",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(changePIN.pending, (state) => {
        state.loading = true;
      })
      .addCase(changePIN.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(changePIN.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default changePINSlice.reducer;
